module.exports = __webpack_public_path__ + "img/10-7.a025942b.jpg";